<template>
	<el-dialog
		:visible.sync="show_multiple_filtered_non_coverage_activities"
		:close-on-click-modal="false"
		:full-screen="true"
		append-to-body
		custom-class="customClass"
	>
		<el-row :gutter="20" class="my-4">
			<el-col :span="16">
				<h2>All Sectional Non Coverage Activities</h2>
			</el-col>
			<el-col :span="8" class="text-right">
				<!-- <el-button
					icon="el-icon-close"
					circle
					size="small"
					@click="show_multiple_filtered_non_coverage_activities = false; filtered_non_coverage_activities = [];"
				></el-button> -->
				<span class="cursor-pointer" style="font-size: 28px; color: #333;" @click="show_multiple_filtered_non_coverage_activities = false; filtered_non_coverage_activities = [];">
					<i class="el-icon-circle-close"></i>
				</span>
			</el-col>
		</el-row>
		<el-row :gutter="20" style="border-bottom: 1px solid #e4e4e4;">
			<el-col :span="6" class="font-bold py-4">
				Activity
			</el-col>
			<el-col :span="6" class="font-bold py-4">
				Function
			</el-col>
			<el-col :span="6" class="font-bold py-4">
				Plan by
			</el-col>
			<el-col :span="6" class="font-bold py-4">
				&nbsp;
			</el-col>
		</el-row>
		<el-row v-for="(element, index) in filtered_non_coverage_activities" :key="'element-key-'+index" :gutter="20" style="border-bottom: 1px solid #e4e4e4;">
			<el-col :span="6" class="py-4 capitalize">
				{{ element.activity_name ? element.activity_name : '-' }}
			</el-col>
			<el-col :span="6" class="py-4 capitalize">
				{{ element.function_name }}
			</el-col>
			<el-col :span="6" class="py-4 capitalize">
				{{ element.plan_by | textUnderscoreToCapitalize }}
			</el-col>
			<el-col :span="6" class="text-right py-4">
				<span class="cursor-pointer">
					<img src="../../../../../assets/icons/edit-icon.svg" width="12" @click="openStoreSettingsNonCoverageActivityModal(element)" />
				</span>
			</el-col>
		</el-row>
	</el-dialog>
</template>

<script>
import settingsMixin from '../../../../../../mixins/settingsMixin'
export default {
	name: "FilteredDailyActivities",
	mixins: [settingsMixin]
}
</script>


<style lang="scss" scoped>
.capitalize {
	text-transform: capitalize;
}
</style>

<style lang="scss">
.customClass {
	.el-dialog__header {
		display: none !important;
	}
	.el-dialog__body {
		padding: 40px !important;
	}
}
</style>